import { MakeEmbedWCCContentBlock } from 'components/content/mixins/embed';
import { DOMHelpers } from 'helpers/dom';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { WCCContentBlock } from '../block/block';
import { WCCContentBlockConfig } from '../block/block.interfaces';

const emojione = require('emojione');

export interface WCCContentAttachmentsBlockConfig extends WCCContentBlockConfig {
    name: SubscribableOrNullableValue<string>
}

const ExtendedWCCContentBlock = [
    MakeEmbedWCCContentBlock(true)
].reduce((result, mixin) => mixin(result), WCCContentBlock);

export class WCCContentEmojiBlock extends ExtendedWCCContentBlock {
    name: Subscribable<string | undefined>
    url: Subscribable<string | undefined>

    constructor(config: WCCContentAttachmentsBlockConfig) {
        super(config);

        this.name = ko.flattenComputed(config.name);
        this.url = this.name.pluck(name => this.getUrl(name));
    }

    protected override getNodes() {
        return DOMHelpers.createBindedNodes(`<img class="emoji" data-bind="attr: { src: url, alt: name, title: name }" />`, { url: this.url, name: this.name });
    }

    private getUrl(name: string) {
        var code = this.toUnicode(name);

        if (code)
            return `${settings.emojioneIconsURL}/${code}.png`;
    }

    private toUnicode(name: string) {
        return _(emojione.emojioneList[name]).last();
    }
}